var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_21)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0212 0.144691C20.0928 0.203361 20.1505 0.27719 20.19 0.360847C20.2296 0.444504 20.2501 0.535902 20.25 0.628441V18.1284C20.2499 18.2729 20.1998 18.4128 20.1082 18.5245C20.0166 18.6361 19.8891 18.7126 19.7475 18.7409L13.4975 19.9909C13.4166 20.007 13.3334 20.007 13.2525 19.9909L7.125 18.7659L0.9975 19.9909C0.906861 20.0091 0.813332 20.0068 0.723651 19.9845C0.63397 19.9621 0.55037 19.9201 0.478874 19.8615C0.407378 19.8029 0.349767 19.7292 0.31019 19.6457C0.270613 19.5621 0.250056 19.4709 0.25 19.3784L0.25 1.87844C0.250087 1.73401 0.300195 1.59406 0.391804 1.4824C0.483413 1.37074 0.610869 1.29425 0.7525 1.26594L7.0025 0.015941C7.08337 -0.000222429 7.16663 -0.000222429 7.2475 0.015941L13.375 1.24094L19.5025 0.015941C19.5931 -0.00228924 19.6866 -0.000197344 19.7763 0.022066C19.866 0.0443293 19.9497 0.0862099 20.0212 0.144691ZM12.75 2.39094L7.75 1.39094V17.6159L12.75 18.6159V2.39094ZM14 18.6159L19 17.6159V1.39094L14 2.39094V18.6159ZM6.5 17.6159V1.39094L1.5 2.39094V18.6159L6.5 17.6159Z",
    fill: "color"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.6d4745c609372f4695c6ebad880a55c8.svg";
export { ForwardRef as ReactComponent };